import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import {Container, Button} from 'components';

import styles from './FooterTable.module.scss';
import Context from '../../context';
import {ModalAllGroups} from '../../components';
import {ADD_GROUP_URL} from '../../constants';

export const FooterTable = ({withModalButton}) => {
  const {dataTable} = useContext(Context);
  const {length} = dataTable;

  return (
    <Container className={styles.wrap}>
      <div>
        <span className={styles.text}>Don’t see the group you’re looking for?</span>
        <Button
          href={ADD_GROUP_URL}
          target="_top"
          type="link"
          className={styles.link}
        >
          Add a group
        </Button>
      </div>
      <div className={styles.left}>
        <span>
          {length} {`group${length !== 1 ? 's' : ''}`}
        </span>
        {withModalButton && (
          <>
            <div className={styles.divider}>|</div>
            <ModalAllGroups />
          </>
        )}
      </div>
    </Container>
  );
};

FooterTable.propTypes = {
  withModalButton: PropTypes.bool,
};

FooterTable.defaultProps = {
  withModalButton: false,
};
